import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import trapFocus from './trap-focus';

window.addEventListener('DOMContentLoaded', () => {
	const popup = document.querySelector<HTMLElement>('[data-popup]');

	const closeBtn = document.querySelectorAll<HTMLElement>('[data-close-btn]');

	if (!popup || !closeBtn) return;

	const messageElement = document.querySelector<HTMLElement>(
		'[data-popup-message]',
	);

	let message: string | null = null;
	if (messageElement) {
		message = messageElement.getAttribute('data-popup-message');
	}

	const setShown = () => {
		if (message) {
			localStorage.setItem('message', message);
		} else {
			localStorage.setItem('message', 'popup shown');
		}
	};

	let releaseFocus: ReturnType<typeof trapFocus> | undefined = undefined;

	const showPopup = () => {
		const msg = localStorage.getItem('message');

		if ((msg !== message && message !== null) || !msg) {
			popup.style.display = 'flex';
			disableBodyScroll(popup);
			releaseFocus = trapFocus(popup);
		}
	};

	const closePopup = () => {
		popup.style.display = 'none';
		enableBodyScroll(popup);
		releaseFocus?.();
		setShown();
	};

	closeBtn.forEach(button => {
		button.addEventListener('click', () => {
			closePopup();
		});
	});

	const handleClickOutside = (e: MouseEvent) => {
		if (e.target && e.target instanceof HTMLElement && popup === e.target) {
			closePopup();
		}
	};

	popup.addEventListener('click', handleClickOutside);

	window.addEventListener('load', () => {
		showPopup();
	});
});
